// Gate for /app routes: wait for the session check, then show the app or send to sign-in.
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './authStore';

export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuth((s) => s.status);
  if (status === 'loading') {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#5f6368', font: '500 14px "Google Sans",Roboto,sans-serif' }}>
        Loading…
      </div>
    );
  }
  if (status === 'anon') return <Navigate to="/login" replace />;
  return <>{children}</>;
}
